{
  "wind-0": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 0,
    "y": 0
  },
  "wind-102": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 0,
    "y": 48
  },
  "wind-107": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 0,
    "y": 96
  },
  "wind-112": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 0,
    "y": 144
  },
  "wind-117": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 0,
    "y": 192
  },
  "wind-12": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 48,
    "y": 0
  },
  "wind-122": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 48,
    "y": 48
  },
  "wind-127": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 48,
    "y": 96
  },
  "wind-132": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 48,
    "y": 144
  },
  "wind-137": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 48,
    "y": 192
  },
  "wind-142": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 96,
    "y": 0
  },
  "wind-147": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 96,
    "y": 48
  },
  "wind-152": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 96,
    "y": 96
  },
  "wind-17": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 96,
    "y": 144
  },
  "wind-202": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 96,
    "y": 192
  },
  "wind-22": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 144,
    "y": 0
  },
  "wind-27": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 144,
    "y": 48
  },
  "wind-32": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 144,
    "y": 96
  },
  "wind-37": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 144,
    "y": 144
  },
  "wind-42": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 144,
    "y": 192
  },
  "wind-47": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 192,
    "y": 0
  },
  "wind-52": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 192,
    "y": 48
  },
  "wind-57": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 192,
    "y": 96
  },
  "wind-62": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 192,
    "y": 144
  },
  "wind-67": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 192,
    "y": 192
  },
  "wind-7": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 240,
    "y": 0
  },
  "wind-72": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 240,
    "y": 48
  },
  "wind-77": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 240,
    "y": 96
  },
  "wind-82": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 240,
    "y": 144
  },
  "wind-87": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 240,
    "y": 192
  },
  "wind-92": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 288,
    "y": 0
  },
  "wind-97": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 336,
    "y": 0
  },
  "wind-variable": {
    "height": 48,
    "pixelRatio": 1,
    "width": 48,
    "x": 384,
    "y": 0
  }
}